import { Component } from '@angular/core';

import { Context } from '../../../../../../../app/core/shared/context.model';
import { ViewMode } from '../../../../../../../app/core/shared/view-mode.model';
import { PersonListElementComponent as BaseComponent } from '../../../../../../../app/entity-groups/research-entities/item-list-elements/person/person-list-element.component';
import { listableObjectComponent } from '../../../../../../../app/shared/object-collection/shared/listable-object/listable-object.decorator';
import { PersonSearchResultListElementComponent } from '../search-result-list-elements/person/person-search-result-list-element.component';

/**
 * BfS: Verwendet den BfS-Listeneintrag für Personen (ohne Vorschaubild), z. B. in "verwandten Items" auf Publikationsseiten.
 */
@listableObjectComponent('Person', ViewMode.ListElement, Context.Any, 'bfs')
@Component({
  selector: 'ds-person-list-element',
  styleUrls: ['../../../../../../../app/entity-groups/research-entities/item-list-elements/person/person-list-element.component.scss'],
  templateUrl: '../../../../../../../app/entity-groups/research-entities/item-list-elements/person/person-list-element.component.html',
  standalone: true,
  imports: [PersonSearchResultListElementComponent],
})
export class PersonListElementComponent extends BaseComponent {
}
